import Vue from 'vue'
import Ant from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';  // or 'ant-design-vue/dist/antd.less'
import App from './App.vue'
import router from './router/index'
import fun from '@/units/apiAction'
import store from './store'
import 'babel-polyfill'
import Es6Promise from 'es6-promise';

require('es6-promise').polyfill()
Es6Promise.polyfill()

// Vue.use(VueSocketio, 'http://192.168.30.120:7003//');
import VueSocketio from 'vue-socket.io';
import socketio from 'socket.io-client';

Vue.use(
    new VueSocketio({
      debug: true ,   // debug调试，生产建议关闭
      connection: socketio(window.g.apiUrl),
    })
)


import VueCropper from 'vue-cropper';
Vue.use(VueCropper);

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
Vue.use(ElementUI)

Vue.use(Ant);

import Base64 from './units/base64.js' 
Vue.prototype.$Base64 = Base64;


//引入百度统计
// var _hmt = _hmt || [];
// window._hmt=_hmt;  //修改为window 全局变量
// (function() {
//   var hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?ad71bf7c8cd6881ee505da522b5f339f";
//   var s = document.getElementsByTagName("script")[0]; 
//   s.parentNode.insertBefore(hm, s);
// })();


// var _hmt = _hmt || [];
// window._hmt=_hmt;  //修改为window 全局变量
// (function() {
//   var hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?efdaf175507eaaf6e607ddb66402c2cb";
//   var s = document.getElementsByTagName("script")[0]; 
//   s.parentNode.insertBefore(hm, s);
// })();



Vue.config.productionTip = false
Vue.prototype.getToken = fun
new Vue({
  render: h => h(App),
  router,
  store,
  fun
}).$mount('#app')
